import React, { useContext, useEffect } from "react";
import { BrowserRouter as Router } from 'react-router-dom';
import './App.scss';
import Loader from './components/common/Loader';
import AppRoutes from './router';
import { RefreshTokenAPI } from "./helpers/helpersMethods";
import storage from "./helpers/storage";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import  { MyContext } from "./MyProvider"


/**
 * Main APP Component Function
 * @returns {*}
 */
const App: React.FC = () => {
 const {setAddSecondaryUser}  = useContext(MyContext)
  useEffect(() => {
    if (storage.getToken() !== null) {
      RefreshTokenAPI(setAddSecondaryUser);
    }
    const refreshInterval = setInterval(() => {
      const refreshTokenData = storage.getData('refresh-token');
      const tokenTime: any = new Date(refreshTokenData ? refreshTokenData.expires : '');
      const now = Date.now();
      const diff = tokenTime.getTime() - now || 0;
      if (!Number.isNaN(tokenTime.getTime()) && diff <= 120000) {
        RefreshTokenAPI(setAddSecondaryUser);
      }
    }, 5000)
    return () => {
      clearInterval(refreshInterval)
    };
  }, [])

  return (
   
    <React.Suspense
      fallback={
        <div className="flex items-center justify-center w-screen h-screen">
          <Loader isLoading={true} />
        </div>
      }
    >
      <Router>
        <AppRoutes />
      </Router>
      <ToastContainer theme="colored" />
    </React.Suspense>
    
  );
}

export default App;
